import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Star(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M15.14 19.16v.001a.568.568 0 00.647-.027.666.666 0 00.243-.68l-1.33-5.97.313-.292 4.031-3.765a.675.675 0 00.172-.698.613.613 0 00-.517-.431l-5.785-.533-.172-.421-2.124-5.205a.601.601 0 00-.55-.389c-.24 0-.457.15-.555.388L7.215 6.78l-.456.04-5.454.48a.613.613 0 00-.523.438.67.67 0 00.183.7l4.48 4.038-.095.427-1.244 5.546a.665.665 0 00.242.68.566.566 0 00.65.026l5.067-3.181 5.074 3.186z"
  }));
}

export { Star };
//# sourceMappingURL=Star.js.map